import IPrice from '../../model/prices/IPrice';
import usePrice from '../prices/usePrice';
import { usePersistedCurrencyPreference } from './usePersistedCurrencyPreference';

const useSelectedCurrencyPrice: (prices: IPrice[]) => { selectedCurrencyPrice: number } = (prices: IPrice[]) => {
  const { primaryPrice, secondaryPrice } = usePrice(prices);
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();

  return {
    selectedCurrencyPrice: isSecondaryCurrencyDisplay ? secondaryPrice.money.amount : primaryPrice.money.amount,
  };
};

export default useSelectedCurrencyPrice;
